import { render } from "./slide-up-down-rgaa.vue?vue&type=template&id=6c744cad"
import script from "./slide-up-down-rgaa.vue?vue&type=script&lang=js"
export * from "./slide-up-down-rgaa.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/legacy/Shared/plugins/slide-up-down-rgaa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c744cad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c744cad', __exports__)) {
    console.log('reload')
    api.reload('6c744cad', __exports__)
  }
  
  module.hot.accept("./slide-up-down-rgaa.vue?vue&type=template&id=6c744cad", () => {
    console.log('re-render')
    api.rerender('6c744cad', render)
  })

}


export default __exports__